import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from 'react'
import axios from 'axios';
import styled, {css} from 'styled-components';

const Li = styled.li`
    display: none;

    ${props => props.active && css`
        display: inline-block;
    `}
`

const DawaAutocompleteInput = () => {
    const [active, setActive] = useState(false);
    const [suggestions, setSuggestions] = useState([])
    const [value, setValue] = useState('')
    const suggestionRef = useRef([]);

    suggestionRef.current = suggestions.map(() => React.createRef());

    useEffect(() => {
        document.addEventListener('click', closeSuggestions)

        return () => {
            document.removeEventListener('click', closeSuggestions)
        }
    }, [])
    

    const getAdresse = (search) => {
        axios({
            method: "GET",
            url: 'https://api.dataforsyningen.dk/adresser/autocomplete',
            params: {
                q: search,
                ['per_side']: 20
            }
        })
            .then(res => {
                setSuggestions(res.data)
            })
            .catch(err => console.error('parsing failed', err))

    }

    const showSuggestions = () => {
        setActive(true);
    }

    const closeSuggestions = () => {
        console.log('stäng')
        setActive(false)
    }

    const handelChange = ({target: { value }}) => {
        setValue(value)

        if (value.length >= 2) {
            getAdresse(value)
        }
    };

    const chooseSuggestion = (index) => {
        setValue(suggestionRef.current[index].current.innerText)
        closeSuggestions();
        console.log('Suggestion: ', suggestions[index].adresse)
    }

    const handelFocus = () => {
        showSuggestions();
    }

    const handelBlure = () => {
        setTimeout(() => {
            setActive(false);
            setSuggestions([]);
        }, 200)
        
    }


    return (
        <Fragment>
            <input
                style={{width: '100%'}}
                onChange={handelChange}
                onFocus={handelFocus} 
                value={value}
            />

            {active && suggestions.map((suggestion, index) => {
                return (
                    <li 
                        key={index}
                        ref={suggestionRef.current[index]}
                        onClick={() => {chooseSuggestion(index)}}
                    >{suggestion.tekst}</li>
                )
            })}
        </Fragment>

    )
}

export default DawaAutocompleteInput